// src/utils/fetchItems.js
import { Config } from "../components/SearchModal/Config";

export async function fetchItems() {
 try {
  const response = await fetch(`/assets/data/items.json?${Config.cacheBuster}`);
  const data = await response.json();
  return data;
 } catch (error) {
  console.error("Error:", error);
  return [];
 }
}
